import { qs } from "@fluorescent/dom";
import { section } from "@/glow";
import { getRecentProducts } from "@/lib/recently-viewed-product-manager";
import { animateStandard, shouldAnimate } from "@/lib/animation";
import { makeRequest } from "@/lib/xhr";
import ProductItem from "@/lib/product-item.js";

const selectors = {
  slider: "scroll-slider-component[data-id='recently-viewed-products']",
  sliderContainer: ".scroll-slider__slider",
  recentlyViewed: "[data-recently-viewed-item]",
};

section("recently-viewed-products", {
  onLoad() {
    const { limit, productHandle } = this.container.dataset;
    this.limit = parseInt(limit, 10);
    this.productItems = document.createElement("div");

    // target the slider container
    this.slider = qs(selectors.slider, this.container);
    this.sliderContainer = qs(selectors.sliderContainer, this.slider);

    // Grab products from localStorage excluding current product and trim to product limit
    const recentProducts = getRecentProducts();

    if (!(recentProducts || []).length) {
      this._removeSection();
      return;
    }

    const recentProductsTrimmed = recentProducts
      .filter(handle => handle !== productHandle) // don't show current product
      .slice(0, this.limit);

    if (recentProductsTrimmed.length >= 1) {
      this._renderProductItems(recentProductsTrimmed);
    } else {
      this._removeSection();
    }
  },

  // render products and init slider
  _renderProductItems(productHandles) {
    const requests = productHandles.map(this._renderProductItem.bind(this));

    Promise.all(requests)
      .then(results => {
        results
          .filter(item => item)
          .forEach(item => this.productItems.appendChild(item));

        this.sliderContainer.innerHTML = this.productItems.innerHTML;
        ProductItem(this.sliderContainer, { afterLoad: true });
        this._initSlider();
      })
      .catch(() => {
        this._removeSection();
      });
  },

  // fetch single product
  _renderProductItem(productHandle) {
    const requestUrl = `${window.theme.routes.products}/${productHandle}?section_id=recently-viewed-product-item`;

    return makeRequest("GET", requestUrl)
      .then(response => {
        const container = document.createElement("div");
        container.innerHTML = response;
        const productItem = container.querySelector(selectors.recentlyViewed);
        return productItem;
      })
      .catch(() => {
        console.error(`Recent product "${productHandle}" not found`);
        return null;
      });
  },

  _initSlider() {
    this.slider.initSlider();

    if (shouldAnimate(this.container)) {
      this.animateListSlider = animateStandard(this.container);
    }
  },

  _removeSection() {
    this.container.parentNode.removeChild(this.container);
  },

  onUnload() {
    this.slider?.destroy();
    this.animateListSlider?.destroy();
  },
});
